module.exports = __webpack_public_path__ + "static/media/CSS_style.68a59aa9.png";